import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: 'mri-master-detail-detail-pane,[mriMasterDetailDetailPane]', standalone: true })
export class MasterDetailDetailPaneDirective {
  @HostBinding('class.mri-master-detail__detail-pane') masterDetailHostClass = true;
}
